module.exports = __webpack_public_path__ + "img/sprite-how-do-i-use-it.ff5f9ea1.png";